import { render } from "./combobox.vue?vue&type=template&id=541a0b3c"
import script from "./combobox.vue?vue&type=script&lang=js"
export * from "./combobox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__